/** @file useEditor: selects a slice of the editor store from context (re-renders when the slice changes). */
import { useContext } from 'react';
import { useStore } from 'zustand';
import { EditorStoreContext } from './editorStoreContext';
import type { EditorActions, EditorState } from './editorTypes';

/** `useEditor((s) => s.selection)`; throws outside an `EditorStoreContext.Provider`. */
export function useEditor<T>(selector: (state: EditorState & EditorActions) => T): T {
  const store = useContext(EditorStoreContext);
  if (store === null) throw new Error('useEditor: no EditorStoreContext.Provider above this component');
  return useStore(store, selector);
}
